import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";
import Seo from "@/components/Seo";
import Hero from "@/sections/Hero";
import ProblemStory from "@/sections/ProblemStory";
import ProductsSection from "@/sections/ProductsSection";
import BundleBanner from "@/sections/BundleBanner";
import FiltrationExperience from "@/sections/FiltrationExperience";
import SustainabilitySection from "@/sections/SustainabilitySection";
import TargetGroups from "@/sections/TargetGroups";
import InstagramFeed from "@/components/InstagramFeed";
import { Testimonials, FinalCta } from "@/sections/MiscSections";

gsap.registerPlugin(ScrollTrigger);

export default function HomePage() {
  // Lenis smooth scrolling on the front page only (desktop pointers)
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    if (reduce || coarse) return;

    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenis.on("scroll", ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);
    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="home-page">
      <Seo
        title="JINSU – puhtaampaa vettä ihollesi ja hiuksillesi"
        description="JINSU-suihkusuodattimet poistavat ruosteen, kloorin ja hienojakoiset epäpuhtaudet juuri ennen käyttöä. Tutustu Jinsu Suodattimeen ja Vitamiinisuodattimiin."
      />
      <Hero />
      <ProductsSection />
      <BundleBanner />
      <ProblemStory />
      <FiltrationExperience />
      <SustainabilitySection />
      <TargetGroups />
      <InstagramFeed />
      <Testimonials />
      <FinalCta />
    </main>
  );
}
